<template>
  <common-page-edit
    :title="title"
    :nameRoleEntity="nameRoleEntity"
    :apiNameGet="apiNameGet"
    :apiNameCreate="apiNameCreate"
    :apiNameUpdate="apiNameUpdate"
    routeNameShow="SupplierShow"
    routeNameCreate="SupplierCreate"
    :keyRoute="'CompanyId'"
    :backUrl="pathBack"
    @set-loadData="setLoadData"
    :convertLoadData="convertLoadData"
    :paramsSave="paramsSave"
    :isDefaultConverter="false"
    :paramsSend="paramsSend"
  >
    <template v-slot:block2>
        <company-data
          :isCodeBudg="false"
          :isCodePers="false"
          :isPerson="false"
          :isSuppServ="true"
          :loadDataIn="loadData"
        ></company-data>
    </template>
  </common-page-edit>
</template>

<script>
import { API_METHODS, FIELD_LANG_COMPANY } from "../../../../constant";
import { NAME_OBJECT } from "../../../../RoleConstanans";
import CommonPageEdit from "../../commonElement/CommonPageEdit.vue";
import CompanyData from "../../../v2/module/company/CompanyData.vue";

import convertFieldInfoListToScheme from "../../../../helpers/converters/convetFieldInfoListToScheme";

export default {
  name: "SupplierEditPageDynamic",
  components: {
    CommonPageEdit,
    CompanyData
  },
  data() {
    return {
      wait: false,
      scheme: {},
      loadData: null,
      fieldInfoList: null,
      preResult: null,
      load: true,

      routeNameShow: "SupplierShow",
      routeNameCreate: "SupplierCreate",

      pathBack: "/company/supplier",
      apiNameGet: API_METHODS.GET_COMPANY,
      apiNameCreate: API_METHODS.CREATE_COMPANY,
      apiNameUpdate: API_METHODS.UPDATE_COMPANY,
      loadData: null
    };
  },
  computed: {
    title() {
      let text1 = this.$t("Просмотр поставщика");
      let text2 = this.$t("Создание поставщика");
      let text3 = this.$t("Редактирование поставщика");

      let findShow = this.$route.path.indexOf("show");
      if (findShow != -1) {
        return text1;
      }
      let findCreate = this.$route.path.indexOf("create");
      if (findCreate != -1) {
        return text2;
      }
      let findEdit = this.$route.path.indexOf("edit");
      if (findEdit != -1) {
        return text3;
      }
      return text1;
    },
    nameRoleEntity() {
      return NAME_OBJECT.supplier;
    },
    paramsSend() {
      return {
        id: this.$route.params.CompanyId || "0",
        typeCompany: "Supplier"
      };
    }
  },

  methods: {
    convertLoadData(res) {
      let loadData = res.object;
      let fieldInfoList = res.fieldInfoList;
      let scheme = { configForm: [] };
      
      let findIndexOgrn = fieldInfoList.findIndex(item => item.code == "psrn");
      let findIndexkpp = fieldInfoList.findIndex(item => item.code == "kpp");
      const temp = {...fieldInfoList[findIndexOgrn]};
      fieldInfoList[findIndexOgrn] =  fieldInfoList[findIndexkpp]
      fieldInfoList[findIndexkpp] = temp;

      scheme.configForm = convertFieldInfoListToScheme({
        fieldInfoList,
        langFieldName: FIELD_LANG_COMPANY
      });

      return {
        loadData,
        fieldInfoList,
        scheme
      };
    },
    setLoadData(loadData) {
      this.loadData = loadData;
    },

    paramsSave() {
      return {
        id: this.$route.params.CompanyId,
        saveData: saveData
      };
    }
  }
};
</script>

